import styled from 'styled-components';
import { Link as LinkRouter } from 'react-router-dom';

export const Nav = styled.nav`
    background-color: #002145;
    height: 60px;
    width: 100%;
    font-weight: 650;
    display: flex;
    align-items: center;
    font-size: 17px;
    position: sticky;
    top: 0;
    z-index: 1000;

    @media screen and (max-width: 960px) {
        transition: 0.8s all ease;
    }
`;

// Mobile sidebar button
export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 955px) {
        display: block;
        position: absolute;
        top: 7px;
        right: 15px;
        font-size: 1.8rem;
        cursor: pointer;
        color: #fff;
    }
`;

// Sub-Page container (right side)

export const NavbarContainer = styled.div`
    display: flex;
    height: 80px;
    z-index: 1;
    justify-content: end;
    width: 100%;
    padding: 0 24px;
`;

// Nav list/link styling and hover stroke
export const NavNav = styled.nav`
    ul li a {
        text-decoration: none;
        color: #FFFFFF;
        position: relative;
    }

    ul li a,
    ul li a:after,
    ul li a:before {
        transition: all .5s;
    }

    ul li a:hover {
        color: #E5B13A;
    }

    ul li a:after {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        margin: auto;
        width: 0%;
        content: '.';
        color: transparent;
        background: #E5B13A;
        height: 3px; 
    }

    ul li a:hover:after {
        width: 100%;
      }
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin: 0;

    @media screen and (max-width: 955px) {
        display: none;
    }
`;

export const NavItem = styled.li`
    height: 80px;
`;

export const NavLinks = styled(LinkRouter)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decorartion: none;
    padding: 0 15px;
    height: 100%;
    cursor: pointer; 

    &.active {
        border-bottom: 3px solid #01bf71
    }

    // className for UBCSolar Logo
    &.logo {
        padding: 24px;
    }
`;
